package com.flowyride.data.account

import com.flowyride.core.api.AccountApi
import com.flowyride.core.api.AdminAction
import com.flowyride.core.api.ManagedUserDto
import com.flowyride.core.api.TemporaryPasswordDto
import com.flowyride.core.api.toDomain
import com.flowyride.core.domain.account.AdminRepository
import com.flowyride.core.domain.account.ManagedUser
import com.flowyride.core.domain.account.UserRole
import com.flowyride.data.account.internal.accountCall
import com.flowyride.data.account.internal.ensureSuccess
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.post
import io.ktor.client.statement.HttpResponse

/** @param client a client built with [withServerSession]. */
class HttpAdminRepository(
    private val client: HttpClient,
    baseUrl: String,
) : AdminRepository {

    private val baseUrl = baseUrl.trimEnd('/')

    override suspend fun users(): List<ManagedUser> = accountCall {
        client.get(baseUrl + AccountApi.ADMIN_USERS).ensureSuccess().body<List<ManagedUserDto>>().map { it.toDomain() }
    }

    override suspend fun approve(userId: Long) = act(userId, AdminAction.APPROVE)

    override suspend fun reject(userId: Long) = act(userId, AdminAction.REJECT)

    override suspend fun revoke(userId: Long) = act(userId, AdminAction.REVOKE)

    override suspend fun setRole(userId: Long, role: UserRole) =
        act(userId, if (role == UserRole.ADMIN) AdminAction.MAKE_ADMIN else AdminAction.MAKE_USER)

    override suspend fun resetPassword(userId: Long): String = accountCall {
        post(userId, AdminAction.RESET_PASSWORD).body<TemporaryPasswordDto>().password
    }

    private suspend fun act(userId: Long, action: AdminAction) = accountCall {
        post(userId, action)
        Unit
    }

    private suspend fun post(userId: Long, action: AdminAction): HttpResponse =
        client.post(baseUrl + AccountApi.adminAction(userId, action)).ensureSuccess()
}
